import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NavbarService } from 'src/app/shared/services/navbar.service';
import { TranslateService } from '@ngx-translate/core';
import { StaticResourcesService } from 'src/app/shared/services/static-resources.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmationModalComponent } from 'src/app/shared/components/confirmation-modal/confirmation-modal.component';
import { SelfManageService } from 'src/app/shared/services/self-manage.service';
import { UpdateIdentityRequest } from 'src/app/shared/models/identity.model';
import { RedirectService } from 'src/app/shared/services/redirect.service';
import { DomSanitizer } from '@angular/platform-browser';
import {AlertService} from "../../shared/services/alert.service";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  subscription: Subscription;

  logo: any;

  currentRoute: string = "";
  private changeLanguageTitle = "";
  private changeLanguageContent = "";

  isCollapsed = true;
  showApplicationsHeader = false;

  constructor(
    private router: Router,
    public navbarService: NavbarService,
    private selfManageService: SelfManageService,
    public translate: TranslateService,
    private bsModalService: BsModalService,
    private staticResourcesService: StaticResourcesService,
    private redirectService: RedirectService,
    private _sanitizer: DomSanitizer,
    private alertService: AlertService,
    private cdr: ChangeDetectorRef

  ) {

  }

  ngOnInit(): void {

    this.initI18N();

  }

  shouldHideHeader(): boolean {
    return (window.location.href.indexOf('TOTP_DESKTOP') !== -1);
  }

  initI18N() {
    //first, get the available languages
    this.staticResourcesService.fetchConfigs()
      .subscribe(
        configs => {

          this.redirectService.customLogoutUrl = configs.logoutUrl;
          this.redirectService.logoutAllSessions = configs.logoutAllSessions;
          let availableLangs: string[] = configs.availableLangs == null ? [] : configs.availableLangs;
          this.showApplicationsHeader = configs.showApplications;
          this.cdr.detectChanges();
          this.translate.addLangs(availableLangs);

          const browserLang = this.translate.getBrowserLang();

          this.selfManageService.fetchDetails()
            .subscribe(
              resp => {
                if(resp.error.length > 0) {
                  this.alertService.error(resp.error)
                }
                var lang = undefined;
                if (resp.language) {
                  lang = resp.language.split("-")[0];
                }

                if (lang && availableLangs.includes(lang)) {
                  this.navbarService.language = lang;
                } else if (availableLangs.includes(browserLang)) {
                  this.navbarService.language = browserLang;
                } else {
                  this.navbarService.language = 'en';
                }
                this.translate.use(this.navbarService.language);
              },
              _ => {
                if (availableLangs.includes(browserLang)) {
                  this.navbarService.language = browserLang;
                } else {
                  this.navbarService.language = 'en';
                }
                this.translate.use(this.navbarService.language);
              }
            );

          //notify about loading i18n resources when done
          this.staticResourcesService.setFetchedTranslation(true);
          this.logo = configs.logoFile;
          //if the logo is not an URI, but rather a raw base64 content, trust it in order to be used on the component
          if (this.logo.startsWith('data:image')) {
            this.logo = this._sanitizer.bypassSecurityTrustResourceUrl(configs.logoFile);
          }
        },
        error => {
          console.log(error);
        }
      );
  }

  onEnrollment() {
    //TODO change hardcoded value with the one from cookies
    // let username:string = "thodoroaba";
    // window.open("/#/enrollment/", "_blank");
    // this.router.navigate(['enrollment',username]);
    // window.open("/#/enrollment/" + username, "_blank");
    if (this.navbarService.identity && this.navbarService.identity.username) {
      this.router.navigate(['enrollment', this.navbarService.identity.username]);
    } else {
      this.router.navigate(['enrollment']);
    }
  }

  async onChangeLang(event) {
    if (this.navbarService.identity) {
      this.translate.get('ACTIVITY.CHANGE_LANGUAGE_TITLE', {value: 'Update profile language?'}).subscribe((res: string) => {
        this.changeLanguageTitle = res;
      });
      this.translate.get('ACTIVITY.CHANGE_LANGUAGE_CONTENT', {value: 'Your profile language will be updated to '}).subscribe((res: string) => {
        this.changeLanguageContent = res;
      });
      const modal = this.bsModalService.show(ConfirmationModalComponent);
      (<ConfirmationModalComponent> modal.content).showConfirmationModal(
        this.changeLanguageTitle,
        this.changeLanguageContent + this.navbarService.language
      );

      (<ConfirmationModalComponent> modal.content).onClose.subscribe(result => {

        if (result === true) {
          this.translate.use(this.navbarService.language);
          this.selfManageService.updateProfile(new UpdateIdentityRequest(this.navbarService.language)).subscribe(_ => { }, _ => { });
        } else if (result === false) {
          // when pressed No
        } else {
          // When closing the modal without no or yes
        }
      });
    } else if (this.router.url.indexOf('enrollment') !== -1) {
      await this.handleChangeLanguageModalDuringEnrollment();
    } else {
      this.translate.use(this.navbarService.language);
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  async handleChangeLanguageModalDuringEnrollment(): Promise<void> {
    const modal = this.bsModalService.show(ConfirmationModalComponent);

    const modalTitle = await this.translate.get('ACTIVITY.CHANGE_LANGUAGE_DURING_ENROLLMENT_TITLE',
      {value: 'Are you sure you want to change website language during enrollment ?'}).toPromise();

    const modalBody = await this.translate.get('ACTIVITY.CHANGE_LANGUAGE_DURING_ENROLLMENT_BODY',
      {value: 'The enrollment process will start from the beginning.'}).toPromise();

    (modal.content as ConfirmationModalComponent).showConfirmationModal(
      modalTitle,
      modalBody
    );

    (modal.content as ConfirmationModalComponent).onClose.subscribe(async result => {
      if (result === true) {
        this.translate.use(this.navbarService.language);
        await this.router.navigate(['']);
        await this.router.navigate(['enrollment']);
      }
    });
  }
}
